export const FaceID = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9241)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <g clipPath="url(#clip0_2954_9241)">
        <path
          d="M72 34.2051V43.2308C72 44.1651 71.2421 44.9231 70.3077 44.9231C69.3733 44.9231 68.6154 44.1651 68.6154 43.2308V34.2051C68.6154 32.6493 67.3507 31.3846 65.7949 31.3846H56.7692C55.8349 31.3846 55.0769 30.6267 55.0769 29.6923C55.0769 28.7579 55.8349 28 56.7692 28H65.7949C69.2169 28 72 30.7831 72 34.2051ZM70.3077 55.0769C69.3733 55.0769 68.6154 55.8349 68.6154 56.7692V65.7949C68.6154 67.3507 67.3507 68.6154 65.7949 68.6154H56.7692C55.8349 68.6154 55.0769 69.3733 55.0769 70.3077C55.0769 71.2421 55.8349 72 56.7692 72H65.7949C69.2169 72 72 69.2169 72 65.7949V56.7692C72 55.8349 71.2421 55.0769 70.3077 55.0769ZM43.2308 68.6154H34.2051C32.6493 68.6154 31.3846 67.3507 31.3846 65.7949V56.7692C31.3846 55.8349 30.6267 55.0769 29.6923 55.0769C28.7579 55.0769 28 55.8349 28 56.7692V65.7949C28 69.2169 30.7831 72 34.2051 72H43.2308C44.1651 72 44.9231 71.2421 44.9231 70.3077C44.9231 69.3733 44.1651 68.6154 43.2308 68.6154ZM44.9231 29.6923C44.9231 28.7579 44.1651 28 43.2308 28H34.2051C30.7831 28 28 30.7831 28 34.2051V43.2308C28 44.1651 28.7579 44.9231 29.6923 44.9231C30.6267 44.9231 31.3846 44.1651 31.3846 43.2308V34.2051C31.3846 32.6493 32.6493 31.3846 34.2051 31.3846H43.2308C44.1651 31.3846 44.9231 30.6267 44.9231 29.6923ZM39.2821 40.9744V43.2308C39.2821 44.1651 40.04 44.9231 40.9744 44.9231C41.9087 44.9231 42.6667 44.1651 42.6667 43.2308V40.9744C42.6667 40.04 41.9087 39.2821 40.9744 39.2821C40.04 39.2821 39.2821 40.04 39.2821 40.9744ZM59.0256 44.9231C59.96 44.9231 60.7179 44.1651 60.7179 43.2308V40.9744C60.7179 40.04 59.96 39.2821 59.0256 39.2821C58.0913 39.2821 57.3333 40.04 57.3333 40.9744V43.2308C57.3333 44.1651 58.0913 44.9231 59.0256 44.9231ZM51.0158 53.497C51.3464 53.8275 51.7794 53.9927 52.2124 53.9927C52.6454 53.9927 53.0795 53.8275 53.4101 53.497C55.3008 51.6041 55.7678 48.7263 54.5724 46.3356L52.642 42.4751C52.2255 41.6355 51.2085 41.3029 50.3714 41.7172C49.5352 42.1357 49.1969 43.1516 49.6146 43.9869L51.545 47.8474C52.0881 48.9359 51.8755 50.2426 51.0149 51.1043C50.3549 51.7654 50.3547 52.8361 51.0158 53.497ZM60.5395 57.5251C60.9537 56.6966 60.6198 55.6963 59.7946 55.2732C58.9717 54.8502 57.9536 55.1785 57.5206 55.996C57.4423 56.1435 55.5584 59.59 50 59.59C44.4416 59.59 42.5577 56.1438 42.4882 56.0136C42.0696 55.174 41.0558 54.8414 40.2176 55.2556C39.3813 55.6742 39.0431 56.69 39.4608 57.5254C39.572 57.7478 42.2736 62.9746 50.0002 62.9746C57.7269 62.9746 60.4282 57.7476 60.5395 57.5251Z"
          fill="#262626"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2954_9241"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9241"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9241"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2954_9241">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(28 28)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
